import type { FeatureAccessStatus } from 'v2/interfaces/featureAccess';

export type Props = {
  transferAccessData: FeatureAccessStatus;
  refetchFeatureAccessData: () => void;
  isLoading: boolean;
  modalTransferIsOpen: boolean;
  hasValueToAnticipate: boolean;
  fetchData: () => void;
  handleToggleTransferModal: () => void;
  handleToggleAnticipateModal: () => void;
};

export type TransferByInvoice = {
  approx_amount: number;
  status: boolean;
  transfer_key: string;
};

export const FIDC_BLOCK = 'FIDC_1';
export const FIDC_BLOCK_WITH_POSSIBILITY_OF_SKIPPING = 'FIDC_2';
export const MESSAGE_LAST_TRANSFER_CANCELLED = 'Sua última transferência foi cancelada. Verifique o motivo em Histórico de Transferências.';
